import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { Modal, Collapse } from 'antd';
import { CloseIcon } from '../../../../../common/icons';
import installersData from './installersData';
import { renderToString } from 'react-dom/server';
import Map from '../../../../../common/components/Map';
import { MarkerEmptyIcon } from '../../../../../common/icons';
import HereService from '../../../../../services/Here';
import constants from '../../../../../constants';

import './InstallerPicker.css';

const { Panel } = Collapse;

const API_KEY = constants.HERE_API_KEY;

@inject('translationsStore')
@observer
export default class InstallerPicker extends Component {
  constructor(props) {
    super(props);
    this.MapRef = React.createRef();
    this.mapservice = new HereService(API_KEY);
    this.MarkerEmptyIcon = renderToString(<MarkerEmptyIcon />);
    this.defaultCenter = {
      lat: 45.464211,
      lng: 9.191383
    };
    this.state = {
      loading: false,
      markers: undefined
    };
  }

  componentDidMount = () => {
    this.loadMarkers();
  };

  loadMarkers = () => {
    const { installers } = this.props;
    let markers = [];
    markers = installers.map(installer => {
      const address = installer.addresses.find(address => address.type === 'operational_office').node;
      return (address.position && address.position.latitude && address.position.longitude) ?
        { id: installer.uuid, coordinates: [address.position.longitude, address.position.latitude] }
      : undefined;
    }).filter(marker => marker);
    this.setState({ markers });
  };

  markersMapper = (marker, index) => {
    const [lng, lat] = marker.coordinates;
    let markerData = {
      icon: this.MarkerEmptyIcon,
      lng,
      lat,
      id: marker.id
    };
    return markerData;
  };

  handleSelectInstaller = installer_uuid => {
    this.props.onChange(installer_uuid);
    this.props.onCancel();
  };

  render() {
    const { translationsStore, installers, value, onCancel } = this.props;
    const { markers } = this.state;
    const cls = classNames({
      [this.props.className]: !!this.props.className
    });
    const { areas } = installersData;
    return (
      <Modal visible={true} onCancel={onCancel} getContainer={this.props.getContainer} footer={null} closable={false} destroyOnClose={true}>
        <div className="InstallerPickerAction" onClick={onCancel} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}>
          <CloseIcon style={{ width: 10, height: 10 }} />
        </div>
        <div className={cls} style={{ display: 'flex', flexDirection: undefined }}>
          <div style={{ position: 'relative', height: 280, width: 500, backgroundColor: 'var(--light-grey)' }}>
            {markers &&
              (markers.length === 0 ? (
                <Fragment>{translationsStore.translate('components.installerPicker.errors.noMapMarkers')}</Fragment>
              ) : (
                <Map
                  ref={this.MapRef}
                  onTap={() => false}
                  className="installersMap"
                  style={{ height: '100%', width: '100%' }}
                  markers={markers}
                  markersMapper={this.markersMapper}
                />
              ))}
          </div>
          <div className="InstallersList" style={{ flex: '1 0 0', marginLeft: 16, height: 280, overflowY: 'scroll' }}>
            <Collapse accordion>
              {areas
                .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))
                .map((area, index) => {
                  return (() => {
                    const areaInstallers = installers.filter(installer => installer.addresses.find(address => address.type === 'operational_office').node.province.toUpperCase() === area.code);
                    return (
                      areaInstallers.length > 0 && (
                        <Panel header={<div className="InstallersListAreaTitle">{area.value}</div>} key={index}>
                          {areaInstallers.map((installer, index) => {
                            const address = installer.addresses.find(address => address.type === 'operational_office').node;
                            const clsAction = classNames({
                              InstallersListItemAction: true,
                              disabled: value === installer.uuid
                            });
                            return (
                              <div key={index} style={{ position: 'relative' }}>
                                <div className="InstallersListItemTitle">{installer.company_name}</div>
                                <div className="InstallersListItemDescription">
                                  {`${address.street} ${address.building_number}`}
                                  <br />
                                  {`${address.postcode} ${address.city} ${address.province}`}
                                  <br />
                                  {installer.phone}
                                </div>
                                <div className={clsAction} onClick={() => value !== installer.uuid && this.handleSelectInstaller(installer.uuid)}>
                                  {translationsStore.translate('common.actionSelect')}
                                </div>
                              </div>
                            );
                          })}
                        </Panel>
                      )
                    );
                  })();
                })}
            </Collapse>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/NewConnectionRequest/InstallerPicker/InstallerPicker.js